import React from "react";
import { Map as MapIcon } from "@mui/icons-material";
import { AdminIconBarItem } from "../icon-bar/AdminIconBarItem";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const MapConfigButton = ({ templateId, onClick, active = false }) => {
  const t = useScrollytellTranslation();

  const handleClick = () => {
    if (onClick) {
      onClick("mapMenu");
    }
  };

  if (templateId === 7) {
    return (
      <AdminIconBarItem
        Icon={MapIcon}
        onClick={handleClick}
        tooltip={t(
          "editSectionPanel.mapConfigTooltip",
          "Kartinnstillinger og stoppesteder"
        )}
        tooltipPosition="top"
        classname={active ? "active-map-menu" : ""}
      />
    );
  }

  return null;
};
